<template>
<div class="danwei_list_dom">
    <div class="danwei_list_item" v-for="(item,index) in tableObj" :key="index" @click="goContent(item)">
        <div class="logo_dom">
            <img v-if="item.clueCorpLogo != '暂无' && item.clueCorpLogo != null" 
            :src="item.clueCorpLogo" 
            :alt="item.clueCorpName"/>
            <div class="logo_div" v-else>
                {{isString(item.clueCorpName)}}
            </div>
        </div>
        <div class="item_dom_content">
            <div class="title_dox">
                <div v-html="item.clueCorpName"></div>
                <div class="tag">{{item.clueCorpStatus}}</div>
            </div>
            <div class="tag_box">
                <div class="tag_box_item">
                    法定代表人：<span>{{item.clueLegalPerson}}</span>
                </div>
                <div class="tag_box_item">
                    注册资本：<span>{{item.clueRegCapital==''? '-':item.clueRegCapital}}</span>
                </div>
                <div class="tag_box_item">
                    成立时间：<span>{{item.clueFoundDate}}</span>
                </div>
            </div>
            <div class="tag_box">
                <div class="tag_box_item">
                    推广平台：
                    <img 
                        v-for="(item1,index) in item.spreadInfo" 
                        :key="index"
                        :src="logoObj[item1]" 
                        style="height: 14px;margin-right: 10px;"/>
                </div>
                <div class="tag_box_item">
                    推广关键词：<span>{{item.keywordCount}}</span>
                </div>
            </div>
            <div class="tag_box" v-if="item.cluePhone != '' && item.cluePhone != null">
                <div class="tag_box_item">
                    电话：<span>{{item.cluePhone}}</span>
                </div>
                <div class="telBtn" v-if="item.phoneCount != '' && item.phoneCount != null" @click.stop="getTel(item.id)">
                    更多电话({{item.phoneCount}})
                </div>
            </div>
        </div>
    </div>
    <el-dialog title="更多电话" :visible.sync="show" width="20%" :before-close="handleClose">
        <el-table :data="telArr" border style="width: 100%">
            <el-table-column label="电话">
                <template slot-scope="scope">
                    <p>{{scope.row}}</p>
                </template>
            </el-table-column>
        </el-table>
    </el-dialog>
</div>
</template>
<script>
var baidu = "https://zyprogram.xinchacha.com/xiansuo/logo/baidu.png";
var sanlou = "https://zyprogram.xinchacha.com/xiansuo/logo/360.png";
var sougou = "https://zyprogram.xinchacha.com/xiansuo/logo/sougou.png";
var shenma = "https://zyprogram.xinchacha.com/xiansuo/logo/shenma.png";
export default {
    name:'danweiListItem',
    data(){
        return{
            logoObj:{
				'1':baidu,
				'2':sanlou,
				'3':sougou,
				'4':shenma
			},
			telArr:[],
			show:false,
            tableObj:this.tableTitle//this.getObj()
        }
    },
    props:{
        tableTitle:Array
    },
    methods:{
        handleClose() {
            this.show = false;
        },
        isString(a){
			var cc = a.replace(/<\/?.+?>/g, "");
			return cc.substring(0,4);
		},
        getObj(){
			var obj = this.tableTitle;
			return obj
		},
        goContent(itemObj){
            return this.$router.push({
                path:'/details',
                query:{
                    id:itemObj.id
                }
            });
        },
        getTel(a){
			var _this = this;
            // _this.show = true;
            this.getRequest("api/clue/getMorePhone/"+a).then(res=>{
                var data = res.data;
                if (data.status == 200) {
                    _this.telArr = data.obj;
					_this.show = true;
                } else {
                    _this.$message.error(data.msg)
                }
            })
        },
        changeTableObj(data){
            this.tableObj = data;
        },
        addTableObj(data){
            var item = data;
            for (let index = 0; index < item.length; index++) {
                this.tableObj.push(item[index]);
            }
        }
    },
    mounted(){

    }
}
</script>
<style lang="scss" scoped>
.danwei_list_dom{
    width: 100%;
    height: auto;
    padding: 30px;
    box-sizing: border-box;
    >div.danwei_list_item{
        width: 100%;
        height: auto;
        display: flex;
        margin-bottom: 20px;
        padding-bottom: 20px;
        border-bottom: 2px solid #F7F8FA;
        >div.logo_dom{
            width: 100px;
            height: auto;
            margin-right: 20px;
            >img{
                width: 100%;
                height: auto;
                display: block;
            }
            >div.logo_div{
                width: 100%;
                height: 100px;
                border-radius: 4px;
                background-image: url('https://zyprogram.xinchacha.com/xiansuo/icon/xinqiye.png');
                background-size: 100px 100px;
                background-position: 100% 100%;
                color: #FFFFFF;
                text-align: center;
                line-height: 44px;
                font-size: 40px;
                padding-top: 5px;
                box-sizing: border-box;
                cursor: default;
            }
        }
        >div.item_dom_content{
            width: calc(100% - 120px);
            height: auto;
            position: relative;
            cursor: default;
            >div.title_dox{
                width: 100%;
                color: #222222;
                font-weight: 400;
                font-size: 22px;
                display: flex;
                >div.tag{
                    width: auto;
                    height: 30px;
                    line-height: 30px;
                    background-color: #DEF8EB;
                    padding: 0 9px;
                    font-size: 16px;
                    color: #349B72;
                    margin-left: 10px;
                }
            }
            >div.tag_box{
                width: 100%;
                height: auto;
                display: flex;
                >div.tag_box_item{
                    color: #999999;
                    font-size: 18px;
                    margin-right: 30px;
                    margin-top: 10px;
                    >span{
                        color: #666666;
                    }
                }
                >div.telBtn{
                    color: #588AE1;
                    font-size: 18px;
                    margin-top: 10px;
                }
            }
        }
    }
}

</style>


// WEBPACK FOOTER //
// src/components/modular/danweiList.vue